import { Alert, Button, FormControl, InputLabel, MenuItem, Select, Stack } from '@mui/material';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  assignCurriculumToCourseMutation,
  getCourseCurriculumAssignmentOptions,
  getCourseCurriculumAssignmentQueryKey,
  listCurriculaOptions,
} from '@drivingdoc/api-client/generated/react-query';

export default function CourseCurriculum({ courseId }: { courseId: string }) {
  const client = useQueryClient();
  const curricula = useQuery(listCurriculaOptions());
  const assignment = useQuery(getCourseCurriculumAssignmentOptions({ path: { courseId } }));
  const assign = useMutation(assignCurriculumToCourseMutation());
  const value = assignment.data?.curriculumId ?? '';

  const save = async (curriculumId: string) => {
    await assign.mutateAsync({ path: { courseId }, body: { curriculumId: curriculumId || null } });
    await client.invalidateQueries({ queryKey: getCourseCurriculumAssignmentQueryKey({ path: { courseId } }) });
  };

  return (
    <Stack spacing={2}>
      <Alert severity="info">
        New students are pinned to the latest published version when they first open the course.
      </Alert>
      <FormControl fullWidth>
        <InputLabel>Curriculum</InputLabel>
        <Select label="Curriculum" value={value} onChange={(event) => save(event.target.value)}>
          <MenuItem value="">No curriculum</MenuItem>
          {curricula.data?.map((curriculum) => (
            <MenuItem key={curriculum.id} value={curriculum.id}>
              {curriculum.title}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {assign.isError && <Alert severity="error">Could not update the curriculum assignment.</Alert>}
      <Button href="/admin/learning/curricula">Manage curricula</Button>
    </Stack>
  );
}
